import { defineStore } from 'pinia'
import auth from '@/utils/auth'
import router, { constantRoutes, dynamicRoutes } from '@/router'

import { getRouters } from '@/api/menu'
import VpBaseLayout from '@/components/layouts/VpBaseLayout.vue'

const modules = import.meta.glob('../../views/**/*.vue')

// import Layout from '@/layout/index'
// import ParentView from '@/components/ParentView'
// import InnerLink from '@/layout/components/InnerLink'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: []
  }),

  actions: {
    // 경로 생성
    GenerateRoutes(roleDeptId) {
      return new Promise((resolve) => {
        // 백엔드에서 라우팅 데이터 요청
        getRouters(roleDeptId).then((res) => {
          const sdata = JSON.parse(JSON.stringify(res.data))
          const rdata = JSON.parse(JSON.stringify(res.data))
          const sidebarRoutes = filterAsyncRouter(sdata)
          const rewriteRoutes = filterAsyncRouter(rdata, false, true)
          const asyncRoutes = filterDynamicRoutes(dynamicRoutes)
          // rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          router.addRoute(asyncRoutes)

          this.addRoutes = rewriteRoutes
          this.routes = constantRoutes.concat(rewriteRoutes)
          this.sidebarRouters = constantRoutes.concat(sidebarRoutes)
          this.defaultRoutes = constantRoutes.concat(sidebarRoutes)
          this.topbarRouters = sidebarRoutes
          resolve(rewriteRoutes)
        })
      })
    }
  },

  getters: {
    getRoutes: (state) => {
      return state.routes
    },
    getAddRoutes: (state) => {
      return state.addRoutes
    },
    getDefaultRoutes: (state) => {
      return state.defaultRoutes
    },
    getTopbarRouters: (state) => {
      return state.topbarRouters
    },
    getSidebarRouters: (state) => {
      return state.sidebarRouters
    }
  }
})

// 백그라운드에서 전송된 라우팅 문자열을 탐색하여 구성 요소 개체로 변환합니다.
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter((route) => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 구성 요소의 특수 처리
      if (route.component === 'Layout') {
        route.component = VpBaseLayout
      } else if (route.component === 'ParentView') {
        // route.component = ParentView
      } else if (route.component === 'InnerLink') {
        // route.component = InnerLink
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route['children']
      delete route['redirect']
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === 'ParentView' && !lastRouter) {
        el.children.forEach((c) => {
          c.path = el.path + '/' + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
      if (el.children && el.children.length) {
        children = children.concat(filterChildren(el.children, el))
        return
      }
    }
    children = children.concat(el)
  })
  return children
}

// 권한 사용 가능 여부를 확인하기 위한 동적 경로 탐색
export function filterDynamicRoutes(routes) {
  const res = []
  routes.forEach((route) => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route)
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route)
      }
    }
  })
  return res
}

const loadView = (component) => {
  return modules['../../views/' + component + '.vue']
}
